/*
 * product-addon-toggle.js
 * Front-end behavior for the stringing toggle. No add-to-cart gating.
 * It only:
 *   1. switches between the Strung and Unstrung panels
 *   2. on Unstrung, sets the select to the no-string value ("")
 *   3. on Strung, restores the recommended (preselected) string
 *
 * Does NOT modify product-addon.js or touch the submit button, so it cannot
 * collide with Concept's sold-out logic.
 *
 * "Don't String" / no-string is the empty-value option (value="").
 */
(function () {
  var NO_STRING_VALUE = '';

  function initAddonToggle(root) {
    if (root.__toggleInit) return;
    root.__toggleInit = true;

    var toggleBtns = root.querySelectorAll('.product-stringing__toggle-btn');
    var panels = root.querySelectorAll('.product-stringing__panel');
    var select = root.querySelector('select');

    // remember the recommended string (whatever is selected at load)
    var recommendedValue = select ? select.value : NO_STRING_VALUE;

    function showPanel(name) {
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-panel') !== name;
      });
    }

    function choose(name) {
      toggleBtns.forEach(function (b) {
        var on = b.getAttribute('data-toggle') === name;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      showPanel(name);

      if (!select) return;

      if (name === 'unstrung') {
        select.value = NO_STRING_VALUE;
      } else {
        // strung: restore recommended if the select is currently empty
        if (!select.value || select.value === NO_STRING_VALUE) {
          select.value = recommendedValue;
        }
      }
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        choose(btn.getAttribute('data-toggle'));
      });
    });

    // default to Strung on load (recommended string already selected in markup)
    choose('strung');
  }

  function boot() {
    document.querySelectorAll('product-addon').forEach(initAddonToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();